import { render, staticRenderFns } from "./MaterialAdd.vue?vue&type=template&id=e204e9d6&"
import script from "./MaterialAdd.vue?vue&type=script&lang=js&"
export * from "./MaterialAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports